import React, {Component} from 'react';
import {
    Badge,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Dropdown
} from 'reactstrap';
import UserAvatar from 'react-user-avatar';
import { Link } from 'react-router-dom';

class HeaderDropdown extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false
        };
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    dropAccnt() {
        return (
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle nav>
                    {this.props.user.name && <UserAvatar src={this.props.user.avatar} size="36" name={this.props.user.name} />}
                    <span className="d-md-down-none drname">{this.props.user.name}</span>
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem header tag="div" className="text-center"><strong>Cuenta de usuario</strong></DropdownItem>
                    <Link to={"/settings"}><DropdownItem><i className="fa fa-wrench"></i> Ajustes</DropdownItem></Link>
                    <DropdownItem onClick={this.props.signOut}><i className="fa fa-lock"></i> Logout</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    }

    render() {
        const {...attributes} = this.props;
        return (
            this.dropAccnt()
        );
    }
}

export default HeaderDropdown;



// WEBPACK FOOTER //
// ./resources/assets/js/components/core/Header/HeaderDropdown.js